import { ListItemText } from '@mui/material';
import React from 'react';
import type { KeyCreditOption } from '../../../types';

type KeyCreditsDropdownOptionProps = {
    option: KeyCreditOption;
};

export default function KeyCreditsDropdownOption({ option }: KeyCreditsDropdownOptionProps) {
    return (
        <ListItemText
            primary={option.label}
            secondary={option.subLabel || null}
            sx={{ width: '100%' }}
            slotProps={{
                primary: {
                    variant: 'body2',
                    sx: { fontWeight: 500 }
                },
                secondary: {
                    variant: 'caption'
                }
            }}
        />
    );
}
